module.exports = __webpack_public_path__ + "img/sectors.5af4d02b.svg";